import { createContext } from '@lit/context';
export const EmbeddedConfigToken = createContext(Symbol('EmbeddedConfigToken'));
//# sourceMappingURL=embedded-config-token.js.map